module.exports = __webpack_public_path__ + "img/myerss.27961302.jpg";